export const states: Record<string, string> = {
  AL: 'Alabama',
  AK: 'Alaska',
  AS: 'American Samoa',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  DC: 'District Of Columbia',
  FM: 'Federated States Of Micronesia',
  FL: 'Florida',
  GA: 'Georgia',
  GU: 'Guam',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MH: 'Marshall Islands',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  MP: 'Northern Mariana Islands',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PW: 'Palau',
  PA: 'Pennsylvania',
  PR: 'Puerto Rico',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VI: 'Virgin Islands',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
};

export const stateBoundaries = [
  {
    state: 'AL',
    xmin: -88.473227,
    ymin: 30.223334,
    xmax: -84.88908,
    ymax: 35.008028,
  },
  {
    state: 'AK',
    xmin: -172.8791,
    ymin: 54.7811,
    xmax: -130.0166,
    ymax: 71.388,
  },
  {
    state: 'AS',
    xmin: -171.089874,
    ymin: -14.548699,
    xmax: -168.1433,
    ymax: -11.046934,
  },
  {
    state: 'AZ',
    xmin: -114.81651,
    ymin: 31.332177,
    xmax: -109.045223,
    ymax: 37.00426,
  },
  {
    state: 'AR',
    xmin: -94.617919,
    ymin: 33.004106,
    xmax: -89.644395,
    ymax: 36.4996,
  },
  {
    state: 'CA',
    xmin: -124.409591,
    ymin: 32.534156,
    xmax: -114.131211,
    ymax: 42.009518,
  },
  {
    state: 'CO',
    xmin: -109.060253,
    ymin: 36.992426,
    xmax: -102.041524,
    ymax: 41.003444,
  },
  {
    state: 'MP',
    xmin: 144.886331,
    ymin: 14.110472,
    xmax: 146.064818,
    ymax: 20.553802,
  },
  {
    state: 'CT',
    xmin: -73.727775,
    ymin: 40.980144,
    xmax: -71.786994,
    ymax: 42.050587,
  },
  {
    state: 'DE',
    xmin: -75.788658,
    ymin: 38.451013,
    xmax: -75.048939,
    ymax: 39.839007,
  },
  {
    state: 'DC',
    xmin: -77.119759,
    ymin: 38.791645,
    xmax: -76.909395,
    ymax: 38.99511,
  },
  {
    state: 'FL',
    xmin: -87.634938,
    ymin: 24.523096,
    xmax: -80.031362,
    ymax: 31.000888,
  },
  {
    state: 'GA',
    xmin: -85.605165,
    ymin: 30.357851,
    xmax: -80.839729,
    ymax: 35.000659,
  },
  {
    state: 'GU',
    xmin: 144.618068,
    ymin: 13.234189,
    xmax: 144.956712,
    ymax: 13.654383,
  },
  {
    state: 'HI',
    xmin: -178.334698,
    ymin: 18.910361,
    xmax: -154.806773,
    ymax: 28.402123,
  },
  {
    state: 'ID',
    xmin: -117.243027,
    ymin: 41.988057,
    xmax: -111.043564,
    ymax: 49.001146,
  },
  {
    state: 'IL',
    xmin: -91.513079,
    ymin: 36.970298,
    xmax: -87.494756,
    ymax: 42.508481,
  },
  {
    state: 'IN',
    xmin: -88.09776,
    ymin: 37.771742,
    xmax: -84.784579,
    ymax: 41.760592,
  },
  {
    state: 'IA',
    xmin: -96.639704,
    ymin: 40.375501,
    xmax: -90.140061,
    ymax: 43.501196,
  },
  {
    state: 'KS',
    xmin: -102.051744,
    ymin: 36.993016,
    xmax: -94.588413,
    ymax: 40.003162,
  },
  {
    state: 'KY',
    xmin: -89.571509,
    ymin: 36.497129,
    xmax: -81.964971,
    ymax: 39.147458,
  },
  {
    state: 'LA',
    xmin: -94.043147,
    ymin: 28.928609,
    xmax: -88.817017,
    ymax: 33.019457,
  },
  {
    state: 'ME',
    xmin: -71.083924,
    ymin: 42.977764,
    xmax: -66.949895,
    ymax: 47.459686,
  },
  {
    state: 'MD',
    xmin: -79.487651,
    ymin: 37.911717,
    xmax: -75.048939,
    ymax: 39.723043,
  },
  {
    state: 'MA',
    xmin: -73.508142,
    ymin: 41.237964,
    xmax: -69.928393,
    ymax: 42.886589,
  },
  {
    state: 'MI',
    xmin: -90.418136,
    ymin: 41.696118,
    xmax: -82.413474,
    ymax: 48.2388,
  },
  {
    state: 'MN',
    xmin: -97.239209,
    ymin: 43.499356,
    xmax: -89.491739,
    ymax: 49.384358,
  },
  {
    state: 'MS',
    xmin: -91.655009,
    ymin: 30.173943,
    xmax: -88.097888,
    ymax: 34.996052,
  },
  {
    state: 'MO',
    xmin: -95.774704,
    ymin: 35.995683,
    xmax: -89.098843,
    ymax: 40.61364,
  },
  {
    state: 'MT',
    xmin: -116.050003,
    ymin: 44.358221,
    xmax: -104.039138,
    ymax: 49.00139,
  },
  {
    state: 'NE',
    xmin: -104.053514,
    ymin: 39.999998,
    xmax: -95.30829,
    ymax: 43.001708,
  },
  {
    state: 'NV',
    xmin: -120.005746,
    ymin: 35.001857,
    xmax: -114.039648,
    ymax: 42.002207,
  },
  {
    state: 'NH',
    xmin: -72.557247,
    ymin: 42.69699,
    xmax: -70.610621,
    ymax: 45.305476,
  },
  {
    state: 'NJ',
    xmin: -75.559614,
    ymin: 38.928519,
    xmax: -73.893979,
    ymax: 41.357423,
  },
  {
    state: 'NM',
    xmin: -109.050173,
    ymin: 31.332301,
    xmax: -103.001964,
    ymax: 37.000232,
  },
  {
    state: 'NY',
    xmin: -79.762152,
    ymin: 40.496103,
    xmax: -71.856214,
    ymax: 45.01585,
  },
  {
    state: 'NC',
    xmin: -84.321869,
    ymin: 33.842316,
    xmax: -75.460621,
    ymax: 36.588117,
  },
  {
    state: 'ND',
    xmin: -104.0489,
    ymin: 45.935054,
    xmax: -96.554507,
    ymax: 49.000574,
  },
  {
    state: 'OH',
    xmin: -84.820159,
    ymin: 38.403202,
    xmax: -80.518693,
    ymax: 41.977523,
  },
  {
    state: 'OK',
    xmin: -103.002565,
    ymin: 33.615833,
    xmax: -94.430662,
    ymax: 37.002206,
  },
  {
    state: 'OR',
    xmin: -124.566244,
    ymin: 41.991794,
    xmax: -116.463504,
    ymax: 46.292035,
  },
  {
    state: 'PA',
    xmin: -80.519891,
    ymin: 39.7198,
    xmax: -74.689516,
    ymax: 42.26986,
  },
  {
    state: 'PR',
    xmin: -67.945404,
    ymin: 17.88328,
    xmax: -65.220703,
    ymax: 18.515683,
  },
  {
    state: 'RI',
    xmin: -71.862772,
    ymin: 41.146339,
    xmax: -71.12057,
    ymax: 42.018798,
  },
  {
    state: 'SC',
    xmin: -83.35391,
    ymin: 32.0346,
    xmax: -78.54203,
    ymax: 35.215402,
  },
  {
    state: 'SD',
    xmin: -104.057698,
    ymin: 42.479635,
    xmax: -96.436589,
    ymax: 45.94545,
  },
  {
    state: 'TN',
    xmin: -90.310298,
    ymin: 34.982972,
    xmax: -81.6469,
    ymax: 36.678118,
  },
  {
    state: 'TX',
    xmin: -106.645646,
    ymin: 25.837377,
    xmax: -93.508292,
    ymax: 36.500704,
  },
  {
    state: 'VI',
    xmin: -65.085452,
    ymin: 17.673976,
    xmax: -64.564907,
    ymax: 18.412655,
  },
  {
    state: 'UT',
    xmin: -114.052962,
    ymin: 36.997968,
    xmax: -109.041058,
    ymax: 42.001567,
  },
  {
    state: 'VT',
    xmin: -73.43774,
    ymin: 42.726853,
    xmax: -71.464555,
    ymax: 45.016659,
  },
  {
    state: 'VA',
    xmin: -83.675395,
    ymin: 36.540738,
    xmax: -75.242266,
    ymax: 39.466012,
  },
  {
    state: 'WA',
    xmin: -124.763068,
    ymin: 45.543541,
    xmax: -116.915989,
    ymax: 49.002494,
  },
  {
    state: 'WV',
    xmin: -82.644739,
    ymin: 37.201483,
    xmax: -77.719519,
    ymax: 40.638801,
  },
  {
    state: 'WI',
    xmin: -92.888114,
    ymin: 42.491983,
    xmax: -86.805415,
    ymax: 47.080621,
  },
  {
    state: 'WY',
    xmin: -111.056888,
    ymin: 40.994746,
    xmax: -104.05216,
    ymax: 45.005904,
  },
  {
    state: 'NA',
    xmin: -124.848974,
    ymin: 24.396308,
    xmax: -66.885444,
    ymax: 49.384358,
  },
  {
    state: 'NS',
    xmin: -124.848974,
    ymin: 24.396308,
    xmax: -66.885444,
    ymax: 49.384358,
  },
];

export const USBounds = {
  xmin: -124.848974,
  ymin: 24.396308,
  xmax: -66.885444,
  ymax: 49.384358,
};

export const statesSettings = [
  {
    label: 'Alabama',
    value: 'AL',
  },
  {
    label: 'Alaska',
    value: 'AK',
  },
  {
    label: 'Arizona',
    value: 'AZ',
  },
  {
    label: 'Arkansas',
    value: 'AR',
  },
  {
    label: 'California',
    value: 'CA',
  },
  {
    label: 'Colorado',
    value: 'CO',
  },
  {
    label: 'Connecticut',
    value: 'CT',
  },
  {
    label: 'Delaware',
    value: 'DE',
  },
  {
    label: 'District of Columbia',
    value: 'DC',
  },
  {
    label: 'Florida',
    value: 'FL',
  },
  {
    label: 'Georgia',
    value: 'GA',
  },
  {
    label: 'Hawaii',
    value: 'HI',
  },
  {
    label: 'Idaho',
    value: 'ID',
  },
  {
    label: 'Illinois',
    value: 'IL',
  },
  {
    label: 'Indiana',
    value: 'IN',
  },
  {
    label: 'Iowa',
    value: 'IA',
  },
  {
    label: 'Kansas',
    value: 'KS',
  },
  {
    label: 'Kentucky',
    value: 'KY',
  },
  {
    label: 'Louisiana',
    value: 'LA',
  },
  {
    label: 'Maine',
    value: 'ME',
  },
  {
    label: 'Maryland',
    value: 'MD',
  },
  {
    label: 'Massachusetts',
    value: 'MA',
  },
  {
    label: 'Michigan',
    value: 'MI',
  },
  {
    label: 'Minnesota',
    value: 'MN',
  },
  {
    label: 'Mississippi',
    value: 'MS',
  },
  {
    label: 'Missouri',
    value: 'MO',
  },
  {
    label: 'Montana',
    value: 'MT',
  },
  {
    label: 'Nebraska',
    value: 'NE',
  },
  {
    label: 'Nevada',
    value: 'NV',
  },
  {
    label: 'New Hampshire',
    value: 'NH',
  },
  {
    label: 'New Jersey',
    value: 'NJ',
  },
  {
    label: 'New Mexico',
    value: 'NM',
  },
  {
    label: 'New York',
    value: 'NY',
  },
  {
    label: 'North Carolina',
    value: 'NC',
  },
  {
    label: 'North Dakota',
    value: 'ND',
  },
  {
    label: 'Ohio',
    value: 'OH',
  },
  {
    label: 'Oklahoma',
    value: 'OK',
  },
  {
    label: 'Oregon',
    value: 'OR',
  },
  {
    label: 'Pennsylvania',
    value: 'PA',
  },
  {
    label: 'Rhode Island',
    value: 'RI',
  },
  {
    label: 'South Carolina',
    value: 'SC',
  },
  {
    label: 'South Dakota',
    value: 'SD',
  },
  {
    label: 'Tennessee',
    value: 'TN',
  },
  {
    label: 'Texas',
    value: 'TX',
  },
  {
    label: 'Utah',
    value: 'UT',
  },
  {
    label: 'Vermont',
    value: 'VT',
  },
  {
    label: 'Virginia',
    value: 'VA',
  },
  {
    label: 'Washington',
    value: 'WA',
  },
  {
    label: 'West Virginia',
    value: 'WV',
  },
  {
    label: 'Wisconsin',
    value: 'WI',
  },
  {
    label: 'Wyoming',
    value: 'WY',
  },
];
